import { render, staticRenderFns } from "./CaseDocumentSidePanel.vue?vue&type=template&id=f7845460"
import script from "./CaseDocumentSidePanel.vue?vue&type=script&lang=js"
export * from "./CaseDocumentSidePanel.vue?vue&type=script&lang=js"
import style0 from "./CaseDocumentSidePanel.vue?vue&type=style&index=0&id=f7845460&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports